import { Button, InputAdornment, TextField } from "@mui/material";
import { IoIosMail } from "react-icons/io";
import { PiLockKeyFill } from "react-icons/pi";
import { useForm } from "react-hook-form";
import { loginFn } from "../api/login";
import { useNavigate } from "react-router-dom";
import storage from "utils/storage";

type LoginFormProps = {
  onSuccess: () => void;
};

export const LoginForm = ({ onSuccess }: LoginFormProps) => {
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm();

  const handleLogin = async (data: any) => {
    try {
      const response = (await loginFn(data)) as any;
      const token = storage.getToken();
      if (token) {
        onSuccess();
      } else {
        setError("root.serverError", {
          type: "server",
          message: response.response?.data.error,
        });
      }
    } catch (error: any) {
      console.error("Login failed:", error);
      setError("root.serverError", {
        type: "server",
        message: error.response?.data.error || "An error occurred during login",
      });
    }
  };

  const navigate = useNavigate();

  return (
    <form onSubmit={handleSubmit(handleLogin)}>
      <div className="flex flex-col w-full gap-4">
        <TextField
          type="email"
          label="Email"
          variant="filled"
          error={errors.email ? true : false}
          helperText={errors.email && "Email is required"}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IoIosMail />
              </InputAdornment>
            ),
          }}
          {...register("username", { required: true })}
        />

        <TextField
          type="password"
          label="Password"
          variant="filled"
          error={errors.password ? true : false}
          helperText={errors.password && "Password is required"}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PiLockKeyFill />
              </InputAdornment>
            ),
          }}
          {...register("password", { required: true })}
        />

        <div className="items-center flex flex-col">
          <Button
            className="!text-2xl w-3/6 text-white"
            variant="contained"
            color="secondary"
            type="submit"
          >
            Log In
          </Button>
          <span className="text-red-500">
            {errors.root?.serverError?.message}
          </span>
        </div>
        <h3
          onClick={() => navigate("/auth/forgotten-password")}
          className="text-black-500 underline cursor-pointer self-center"
        >
          Forgot Password?
        </h3>
      </div>
    </form>
  );
};
